import React, { useState } from "react";
import { Button, Modal, Tabs, Tab } from "react-bootstrap";
import PrimarySidebar from "../PrimarySidebar/PrimarySidebar";

const ProjectsList = [
  {
    id: 1,
    protitle: "E-commerce Website Development",
    budget: "$10,000 - $20,000",
    hourlyRate: "$50 - $100/hr",
    location: "Remote",
    status: "high_intent",
    description:
      "Looking for an experienced web development team to build a scalable e-commerce platform with payment integration.",
    lookingToStart: "immediately",
    name: "John Doe",
    email: "johndoe@example.com",
    phone: "123-456-7890",
  },
  {
    id: 2,
    protitle: "Mobile App for Fitness Tracking",
    budget: "$5,000 - $15,000",
    hourlyRate: "$40 - $80/hr",
    location: "United States",
    status: "outbound",
    description:
      "Need a cross-platform mobile app for tracking workouts, diet plans, and progress with AI-based recommendations.",
    lookingToStart: "30_60",
    name: "Jane Smith",
    email: "janesmith@example.com",
    phone: "987-654-3210",
  },
  {
    id: 3,
    protitle: "React Native support",
    budget: "$5,000 - $15,000",
    hourlyRate: "$40 - $80/hr",
    location: "United States",
    status: "inbound",
    description:
      "Need a cross-platform mobile app for tracking workouts, diet plans, and progress with AI-based recommendations.",
    lookingToStart: "30_60",
    name: "Jane Smith",
    email: "janesmith@tcs.com",
    phone: "987-654-3210",
  },
  {
    id: 4,
    protitle: "AWS Architecture Design",
    budget: "$5,000 - $15,000",
    hourlyRate: "$40 - $80/hr",
    location: "United States",
    status: "referral",
    description:
      "Need a cross-platform mobile app for tracking workouts, diet plans, and progress with AI-based recommendations.",
    lookingToStart: "30_60",
    name: "Jane Smith",
    email: "janesmith@example.com",
    phone: "987-654-3210",
  },
];

// Sample company list for forwarding (unused now, but kept for reference)
const CompanyList = [
  {
    id: 1,
    name: "Veritis Group Inc.",
    logo: "https://www.veritis.com/wp-content/themes/veritis/theme/img/logo.svg",
    rating: 4.5,
  },
  {
    id: 2,
    name: "Wipro",
    logo: "https://www.wipro.com/content/dam/wipro/social-icons/wipro_new_logo.svg",
    rating: 4.2,
  },
  {
    id: 3,
    name: "Tech Mahindra",
    logo: "https://www.opentext.com/assets/images/partners/tech-mahindra-logo-416x278.png",
    rating: 4.0,
  },
  {
    id: 4,
    name: "Infosys",
    logo: "https://static.vecteezy.com/system/resources/previews/020/336/451/non_2x/infosys-logo-infosys-icon-free-free-vector.jpg",
    rating: 4.3,
  },
];

const LeadsDashboard = () => {
  const [projects, setProjects] = useState(ProjectsList);
  const [selectedProject, setSelectedProject] = useState(null);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [newStatus, setNewStatus] = useState("");

  const handleStatusChange = (project, status) => {
    setSelectedProject(project);
    setNewStatus(status);
    setShowStatusModal(true);
  };

  const handleConfirmStatus = () => {
    setProjects((prev) =>
      prev.map((p) =>
        p.id === selectedProject.id ? { ...p, status: newStatus } : p
      )
    );
    setShowStatusModal(false);
    setSelectedProject(null);
    setNewStatus("");
  };

  const renderCardContent = (project) => (
    <div className="card mx-2 mb-3 p-4 border-0 shadow-sm ls-profile rounded-4">
      <h6 className="mb-3">{project.protitle}</h6>
      <div className="d-flex justify-content-between pb-3">
        <div className="badge small p-2 border-primary text-primary">
          {project.lookingToStart === "immediately"
            ? "Immediate"
            : project.lookingToStart.replace("_", "-") + " days"}
        </div>
      </div>
      <p className="text-muted small mb-2">{project.description}</p>
      <div className="d-block justify-content-between border-top py-2 pb-3 num-stat my-3 border-bottom w-100 gap-5">
        <ul className="list-group-info">
          <li className="list-group-info d-flex justify-content-between py-2">
            <span className="small fw-500">Budget</span> <span className="fw-600 small text-end">{project.budget}</span>
          </li>
          <li className="list-group-info d-flex justify-content-between py-2">
            <span className="small fw-500">Posted Date</span> <span className="fw-600 small text-end">Feb 14 2024</span>
          </li>
        </ul>
      </div>

      {/* Uniform Buttons for Every Card */}
      <div className="d-flex mt-2">
        <button
          className="btn btn-primary me-3"
          onClick={() => handleStatusChange(project, "accepted")}
        >
          Accept
        </button>
        <button
          className="btn btn-outline-primary text-primary"
          onClick={() => handleStatusChange(project, "rejected")}
        >
          Reject
        </button>
      </div>
    </div>
  );

  return (
    <>
      <PrimarySidebar />
      <div className="js-pg-hg mt-5">
        <div className="container cp-container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="heading mb-4 pb-1">
                <h4>Get Leads</h4>
              </div>

              {/* React-Bootstrap Tabs */}
              <Tabs
                defaultActiveKey="high_intent"
                id="edit-profile-tabs"
                className="mb-4 pb-3 fw-500 text-dark border-bottom-0"
                variant="pills"
                justify
              >
                <Tab eventKey="high_intent" className="" title={
          <>
            <p className="mb-3">High Intent <span className="badge border-light shadow-sm ms-2 rounded-5 p-2 fw-600 m-0 bg-white small text-primary">30</span></p>
            </>
        }>
                  <div className="row">
                    {projects.map((project) => (
                      <div key={project.id} className="col-md-4 mb-4">
                        {renderCardContent(project)}
                      </div>
                    ))}
                  </div>
                </Tab>

                <Tab eventKey="outbound" title={
          <>
            <p className="mb-3">Outbound <span className="badge border-light shadow-sm ms-2 rounded-5 p-2 fw-600 m-0 bg-white small text-primary">15</span></p>
            </>
        }>
                  <div className="row">
                    {projects.map((project) => (
                      <div key={project.id} className="col-md-4 mb-4">
                        {renderCardContent(project)}
                      </div>
                    ))}
                  </div>
                </Tab>

                <Tab eventKey="inbound" title={
          <>
            <p className="mb-3">Inbound <span className="badge border-light shadow-sm ms-2 rounded-5 p-2 fw-600 m-0 bg-white small text-primary">18</span></p>
            </>
        }>
                  <div className="row">
                    {projects.map((project) => (
                      <div key={project.id} className="col-md-4 mb-4">
                        {renderCardContent(project)}
                      </div>
                    ))}
                  </div>
                </Tab>

                <Tab eventKey="referral" title={
          <>
            <p className="mb-3">Referral <span className="badge border-light shadow-sm ms-2 rounded-5 p-2 fw-600 m-0 bg-white small text-primary">25</span></p>
            </>
        }>
                  <div className="row">
                    {projects.map((project) => (
                      <div key={project.id} className="col-md-4 mb-4">
                        {renderCardContent(project)}
                      </div>
                    ))}
                  </div>
                </Tab>
              </Tabs>

              {/* Status Confirmation Modal */}
              <Modal
                show={showStatusModal}
                onHide={() => setShowStatusModal(false)}
                centered
                className="shadow-lg"
                dialogClassName="modal-dialog-rounded"
              >
                <Modal.Header
                  closeButton
                  className="text-white border-bottom-0 rounded-top-3 px-4 py-3"
                >
                  <Modal.Title className="fw-600 fs-5">
                    Confirm Status Change
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-5 bg-light rounded-3">
                  <p className="text-center mb-0 fs-5">
                    Are you sure you want to mark this project as{" "}
                    {newStatus.toUpperCase()}?
                  </p>
                  <div className="border-top-0 p-4 bg-light rounded-bottom-3 mt-0 d-flex justify-content-center">
                    <Button
                      variant="outline-primary text-primary"
                      className="rounded-2 px-4 py-2 fw-medium me-2"
                      onClick={() => setShowStatusModal(false)}
                    >
                      No
                    </Button>
                    <Button
                      variant="primary"
                      className="rounded-2 px-4 py-2 fw-medium"
                      onClick={handleConfirmStatus}
                    >
                      Yes, I'm Confirmed
                    </Button>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadsDashboard;